import React from "react";
import { Button } from "@aqar-app/aqar-design-system";
import { useRouter } from "next/router";
import classnames from "classnames/bind";
import style from "../.module.scss";
import { getRemainingTimeFromNow } from "@/lib/dateHelpers";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { StickyContainer } from "@/components/Listing/ListingScreen/bidding-section/BiddingDetails";

const cx = classnames.bind(style);

const BiddingActionBar = ({ endDate, isListingOwner, hasPrevBid, status }) => {
  const { token } = useAuthState();
  const router = useRouter();
  const limiterRef = React.useRef();

  const calculateTimeLeft = () => {
    const diff = getRemainingTimeFromNow(endDate);
    return {
      days: Math.floor(diff.asDays()),
      hours: diff.hours(),
      minutes: diff.minutes(),
      seconds: diff.seconds(),
    };
  };

  const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const handleBidClick = () => {
    if (!token) {
      router.push("/login");
      return;
    }

    let mode = "bid";
    if (isListingOwner) {
      mode = "bidders";
    }
    router.push({
      hash: mode,
    });
  };

  let buttonCopy = hasPrevBid ? "تعديل العرض" : "تقديم عرض شراء";
  if (isListingOwner) {
    buttonCopy = "استعراض العروض";
  }

  const buttonClassNames = cx("biddingButtons", {
    owner: isListingOwner,
  });

  return (
    <>
      <div ref={limiterRef} />
      <StickyContainer className={style.sticky}>
        <div className={style.biddingActionBar + " " + style.card}>
          <div className={style.biddingTimer}>
            <div className={style.text}>ينتهي استقبال العروض بعد:</div>
            <div className={style.time}>
              {status === "opened"
                ? `${timeLeft.days} أيام : ${timeLeft.hours} ساعة : ${timeLeft.minutes} دقيقة : ${timeLeft.seconds} ثانية`
                : "إنتهى الوقت"}
            </div>
          </div>
          <div>
            <Button
              className={buttonClassNames}
              size=""
              onClick={handleBidClick}
              disabled={!isListingOwner && status === "closed"}
            >
              {buttonCopy}
            </Button>
          </div>
        </div>
      </StickyContainer>
    </>
  );
};

BiddingActionBar.propTypes = {};

export default BiddingActionBar;
